(function( $ ) {
    $('form.newsletter').submit(function(e){
      let nonce = $('form.newsletter .nonce').val();
      let email = $('form.newsletter .email').val();
      let list = $('form.newsletter .list:checked').val();
      let gdpr = 1;
  
      $.ajax({
        type: 'POST',
        url: ajax.ajax.url,
        data: {
          action: 'subscribe_to_mailchimp',
          nonce: nonce,
          email: email,
          gdpr: gdpr,
        },
        success: function(result) {
          $('.newsletter .response').html( result ).show();
        },
        error: function(errorThrown){
          console.log(errorThrown);
        }
      });
  
      e.preventDefault();
    })
  })(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partial/newsletter.js